import { Link } from "react-router";
import btWhatsapp from "@assets/budget/qr-code-whatsapp.svg";
import defaultMastheadImage from "@assets/logo-masthead.svg";
import { getIconSrc } from "@components/Icon/utils/helpers";
import { IconTypeEnum } from "@components/Icon/utils/types";
import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";
import { GACustomEvent } from "@typings/GoogleAnalytics";

type WhatsappProps = {
  gaObject: GACustomEvent;
};
/**
 * Whatsapp banner that is displayed on right side panel
 * https://www.figma.com/design/QCEPjsj7Sdm5KqnY3ta5tq/TEMPLATES--WEB---APP-?node-id=1-12559&t=NMzsh6SczSQjIa80-4
 */
const Whatsapp = ({ gaObject }: WhatsappProps): React.ReactElement => {
  const sendDataToGTM = useGTMDispatch();

  const handleOnClickLink = () => {
    sendDataToGTM(gaObject);
  };

  return (
    <div
      className="relative border border-gray-850 p-2"
      data-testid="whatsapp-component"
    >
      <div className="bg-gray-250 p-6">
        <div className="relative flex w-full flex-none justify-center md:hidden">
          <img
            src={defaultMastheadImage}
            alt="The Business Times"
            width={170}
            height={15}
          />
        </div>

        <img
          src={getIconSrc(IconTypeEnum.whatsapp)}
          width={48}
          height={48}
          alt="whatsapp icon"
          className="mx-auto hidden md:block"
        />

        <h3 className="mt-4 hidden text-center font-lct text-6xl font-normal text-gray-850 md:block">
          Follow BT on
        </h3>

        <h3 className="hidden text-center font-lct text-6xl font-normal text-gray-850 md:block">
          Whatsapp
        </h3>

        <p className="my-5 text-center font-lct text-8xl text-gray-850 md:mt-2 md:px-2 md:py-0 md:font-poppins md:text-xs md:font-light">
          Breaking news and top stories, delivered right to your phone.
        </p>

        <img
          src={btWhatsapp}
          width={136}
          height={136}
          alt="BT Whatsapp"
          className="mx-auto mt-4 hidden md:block"
        />

        <p className="mb-0 mt-2 hidden text-center text-7xs uppercase md:block">
          Scan the QR Code
        </p>

        <div className="mx-auto flex w-max items-center rounded border border-gray-850 bg-white px-10 py-3 text-center md:hidden">
          <img
            src={getIconSrc(IconTypeEnum.whatsapp)}
            width={30}
            height={30}
            alt="whatsapp icon"
          />

          <p className="font-poppins text-xs font-bold">BT on WhatsApp</p>
        </div>
      </div>

      <Link
        onClick={handleOnClickLink}
        to={"https://www.whatsapp.com/channel/0029VaI0vLF29753DedKkb24"}
        target="_blank"
        className="absolute inset-0"
      />
    </div>
  );
};

export default Whatsapp;
